import * as React from "react";
import { Field } from "formik";
import styled from "styled-components";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Input } from "components/bootstrap";
import { Select } from "components/common";
import { defaultCompare } from "logic/DefaultCompare";
import StreamsContext from "contexts/StreamsContext";
const FieldContainer = styled.div`
  flex-basis: 100%;
`;
const StreamFilterFieldValue = ({ fieldName }) => {
  const { t } = useTranslation("enterprise_data_lake");
  const streams = useContext(StreamsContext);
  const streamOptions = streams.map((stream) => ({
    key: stream.title,
    value: stream.id
  })).sort(({ key: key1 }, { key: key2 }) => defaultCompare(key1, key2));
  return /* @__PURE__ */ React.createElement(Field, { name: fieldName, required: true }, ({ field: { name, value, onChange }, meta: { error } }) => /* @__PURE__ */ React.createElement(FieldContainer, null, /* @__PURE__ */ React.createElement(Input, { error, name, formGroupClassName: "", id: name }, /* @__PURE__ */ React.createElement(
    Select,
    {
      options: streamOptions,
      value: Array.isArray(value) ? value == null ? void 0 : value.join(",") : value,
      displayKey: "key",
      multi: true,
      inputId: name,
      onChange: (newVal) => {
        onChange({ target: { value: newVal == null ? void 0 : newVal.split(","), name } });
      },
      placeholder: t("stream_filter.placeholder"),
      allowCreate: false
    }
  ))));
};
export default StreamFilterFieldValue;
